import appGlobalScript from '/Users/checoelho/Desktop/culturehacklabs/code/culturehack-semantic-search/src/global/app.ts';
export const globalScripts = appGlobalScript;
